import { useNavbarHeightContext } from "context/NavbarHeightContext";
import { ERROR_COLOR } from "ds_legacy/materials/colors";
import { dp, padding } from "ds_legacy/materials/metrics";
import { Subheading } from "ds_legacy/materials/typography";
import { AlertTriangleIcon } from "lucide-react";
import styled from "styled-components";
import { useTranslations } from "translations";

type PageContainerProps = {
  navbarHeight?: number;
};

export const PageContainer = styled.div<PageContainerProps>`
  box-sizing: border-box;
  max-width: ${dp(1200)};
  padding: ${padding(2)};
  place-self: center;
  width: 100%;
  margin-top: ${({ navbarHeight }) => dp(navbarHeight ?? 0)};
`;

export const FlexBox = styled.div({
  alignItems: "center",
  boxSizing: "border-box",
  display: "flex",
  height: "100%",
  justifyContent: "center",
  width: "100%",
});

export default function RestrictedAccess() {
  const translations = useTranslations();
  const { height } = useNavbarHeightContext();

  return (
    <FlexBox>
      <PageContainer navbarHeight={height}>
        <FlexBox>
          <AlertTriangleIcon style={{ color: ERROR_COLOR }} size={16} />
          <Subheading error>
            {translations.general.notAuthorizedToAccessThisPage}
          </Subheading>
        </FlexBox>
      </PageContainer>
    </FlexBox>
  );
}
